import styled from 'styled-components';
import { getColor } from 'styles/theme';
import type { Theme } from 'styles/theme';

export const AuthorsBioCards = styled.div<{ theme: Theme }>`
  margin: var(--Section-Margin) 0;
  content-visibility: auto;
  h4 {
    margin-top: 8px;
    margin-bottom: 0;
    padding-bottom: 24px;
    border-bottom: 4px solid ${getColor('borderBlack')};
  }

  .author-bio {
    ul {
      list-style-type: none;
      padding: 0;
    }
  }

  svg {
    fill: ${getColor('neutralBlack')};
  }

  &.shrink-spacing {
    margin: calc(var(--Section-Margin) / 2) 0;

    h4 {
      margin-top: 4px;
      padding-bottom: 12px;
    }

  }
`;

export default AuthorsBioCards;
